<template>
  <div class="hello">
      <div class='container'>
            <transition name="fade">
                <div v-if="loadingItems" class="loading">
                    <p>{{loadingMessage}}</p>
                </div>
            </transition>
        </div>

    <b-container>
        <b-row>
            <b-col>
                <h2 style="margin-top:20px">Keg Seeker Trading Post</h2>
            </b-col>
        </b-row>
        <!-- Add an item for sale -->
        <b-row>
            <b-col>
                <b-button style="margin-top:20px" variant='success' size='lg' @click="goToAddItem()">Post Something for Sale</b-button>
            </b-col>
        </b-row>

        <!-- Seach box -->
        <b-button-toolbar>
            <div class="input-group" style="margin-top:20px; margin-bottom:20px">
                <b-form-input size="xl" type="text"  v-model="searchPhrase" class="form-control" placeholder="Search For Something"   @keyup.enter="searchForPhrase()">
                </b-form-input>
                <div class="input-group-append">
                    <b-button size="m" class="btn btn-info" type="button" @click="searchForPhrase()" > 
                        <font-awesome-icon icon="search" />
                    </b-button>
                </div>
            </div>
        </b-button-toolbar>

        <!-- Close search button -->
        <b-row  v-if='isShowingSearchResults'>
            <b-col>  
                <label onmouseover="" style="cursor: pointer; font-size:20px; border: 1px solid grey; border-radius:5px; background-color:#f2f2f2"  @click="closeSearchResults()"><span style=" margin-left:15px; margin-right:15px">{{searchPhrase}} <font-awesome-icon icon="times-circle" style="padding-right:5px; font-size:25px"/></span></label>
            </b-col>
        </b-row>

        <!-- Nothing found in search -->
        <b-row v-if="isShowingSearchResults&&searchItemsList.length<=0">
            <b-col>
                <h6>Sorry, nothing found</h6>
            </b-col>
        </b-row>

        <!-- Page controls -->
    <b-row id='toppagecontrol'>
        <b-col  sm="9">
            <b-pagination  size="sm"
                v-model="currentPage"
                :total-rows="totalLength"
                :per-page="perPage"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
            ></b-pagination>
        </b-col>
        <b-col sm="3">
                <b-form-group  label-size="sm" 
                    label-cols-sm="6"
                    label="Per Page"
                    label-align-sm="right"
                    label-for="size"
                    style="width:auto"
                    >
                    <b-form-select size="sm"
                        style="width:auto"
                    id="size"
                    v-model="perPage"
                    :options="pageOptions"
                    ></b-form-select>
                </b-form-group>
        </b-col>
    </b-row>

        <!-- Iterate over all items -->
        <b-row>
            <b-card  v-for="item in getDisplayArray" style="width:250px; cursor:pointer; margin-left:10px; margin-top:20px" :key="item.id" header-tag="header" footer-tag="footer" @click="clickedItem(item)">
                <template #header>
                    <h6 class="mb-0" style="height:50px">{{getTruncatedTitle(item)}}</h6>
                </template>
                <div style="height:125px; text-align: center; cursor:pointer">
                    <img :src="getImageSource(item)" height="90" fluid alt="Logo image">
                </div>
                <template #footer>
                    <h4 style="color:green">$ {{item.price}}</h4>
                </template>
            </b-card>
        </b-row>
    </b-container>

    <div id="footerid">
        <footer><pagefooter/></footer>
    </div>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')
import Pagefooter from '../Pagefooter'
import Saleitemdetails from './Saleitemdetails'


export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser']),
        //Main display array
        getDisplayArray: function () {

            var displayBeerList=[]
            var paginatedList = []
            if(!this.isShowingSearchResults) displayBeerList=this.itemsForSale
            else displayBeerList=this.searchItemsList

            this.totalLength = displayBeerList.length

            var indexStart = (parseInt(this.currentPage-1))*parseInt(this.perPage)
            var indexStop = indexStart + parseInt(this.perPage)

            if (indexStop>displayBeerList.length) indexStop = displayBeerList.length

            for (var k = indexStart; k<indexStop; k++){
                paginatedList.push(displayBeerList[k])
            }
            return paginatedList
        },
        

    },

    components: {
        Pagefooter,
        Saleitemdetails,
        
    },

    data() {
        return {
            loadingItems:false,
            loadingMessage:'',
            itemsForSale:[],
            searchItemsList:[],
            isShowingSearchResults:false,
            searchPhrase:'',
            currentPage:1,
            perPage:25,
            pageOptions: [
                    { value: '24', text: '25' },
                    { value: '48', text: '50' },
                    { value: '96', text: '100' },
                    { value: '9999999999999', text: 'All' },
                    ],
            totalLength:0,

        }
    },

    methods:{
        getItemsForSale(){
            this.loadingMessage="Loading Items"
            this.loadingItems=true
            var localSalesList=[]
            fb.forSaleCollection.where("state", "==", this.userProfile.state).where("county", "==", this.userProfile.county).where("sold","==",0).get().then(docs => {
                docs.forEach(doc => {
                    //Get minimum price
                    var saleData = doc.data()
                    saleData.docId = doc.id
                    localSalesList.push(saleData)
                    //Add to brewers list
                })
                })
            .then(res => {
                this.itemsForSale=localSalesList
                this.loadingItems=false
                console.log("Sales list = ")
                console.log(this.itemsForSale)
            }).catch(err => {
                this.loadingItems=false
                console.log("Error getting items")
            })
        },

        //Get image for item
        getImageSource(item){
            var imageURL=''
            if(item.imagethumburl1) imageURL= item.imagethumburl1
            else if(item.imagethumburl2) imageURL= item.imagethumburl2
            else if(item.imagethumburl3) imageURL= item.imagethumburl3
            else if(item.imagethumburl4) imageURL= item.imagethumburl4
            else if(item.imagethumburl5) imageURL= item.imagethumburl5
            else if(item.imagethumburl6) imageURL= item.imagethumburl6
            else imageURL= require('../../assets/beer.jpg')

            return imageURL

        },
        //Get truncated title if too long
        getTruncatedTitle(item){
            var theTitle = item.title
            if(theTitle.length>50) theTitle = theTitle.slice(0, 50) + '....'
            return theTitle
        },

        //Item clicked
        clickedItem(item){
            //this.$bvModal.show('modalitem' + itemId)
            this.$store.commit('setSelectedSaleItem',item)
            this.$router.push('/saleitemdetails')
        },

        //Search
        searchForPhrase(){
            
            //Return if too short
            if(this.searchPhrase.length<1) return
            this.isShowingSearchResults=true,
            console.log("Searching")
            this.searchItemsList=[]
            this.loadingItems = true
            this.loadingMessage="Searching"
            setTimeout(() => { this.loadingItems = false }, 1500)
            var localSearchList=[]

            //Split string into individual phrases
            var string = this.searchPhrase
            string = string.split(" ")
            var stringArray = new Array()
            for(var i =0; i < string.length; i++){
                stringArray.push(string[i])
            }

            var searchArrayLength = stringArray.length

            //Iterate over search phrase array
            for (var j=0; j<searchArrayLength; j++){
                var lowerCaseSearchPhrase = stringArray[j].toLowerCase()

                //Remove special chars
                lowerCaseSearchPhrase = lowerCaseSearchPhrase.replace(/[^a-zA-Z ]/g, "")

                //Skip empty
                if(!lowerCaseSearchPhrase||lowerCaseSearchPhrase==''||lowerCaseSearchPhrase==' '||lowerCaseSearchPhrase.length<2) continue

                //Iterate over all items
                for (var i in this.itemsForSale) {
                    var thisItem = this.itemsForSale[i]
                    var searchTermsFound = 0
                    var thisItemTitle = thisItem.title.toLowerCase()
                    var thisItemDescription = thisItem.description.toLowerCase()
                    var titleSearchResult = -20
                    var descriptionSearchResult  = -20
                    titleSearchResult = thisItemTitle.search(lowerCaseSearchPhrase);
                    descriptionSearchResult = thisItemDescription.search(lowerCaseSearchPhrase);

                    if (titleSearchResult>-1){
                        searchTermsFound = searchTermsFound + 6
                    } 
                    if (descriptionSearchResult>-1){
                        searchTermsFound = searchTermsFound + 4
                    } 

                    //Check if search succesfull
                    if ((titleSearchResult>-1)||(descriptionSearchResult>-1)){
                        //Check if already exists
                        const searchIndex = localSearchList.findIndex(item => item.id === thisItem.id);
                        if (searchIndex !== -1){
                            if (thisItem.searchTermsFound) thisItem.searchTermsFound = thisItem.searchTermsFound + searchTermsFound
                            else thisItem.searchTermsFound =  searchTermsFound
                            localSearchList.splice(searchIndex, 1, thisItem)

                        } 
                        else {
                            thisItem.searchTermsFound =  searchTermsFound
                            localSearchList.push(thisItem)
                        }

                    }

                }
                //Sort the array
                function compare(a, b) {
                    const brewerA = a.searchTermsFound;
                    const brewerB = b.searchTermsFound;
                    let comparison = 0;
                    if (brewerA <brewerB) {
                        comparison = 1;
                    } else if (brewerA>brewerB) {
                        comparison = -1;
                    }
                    return comparison;
                }
                localSearchList.sort(compare);
                this.searchItemsList=localSearchList
                console.log("Search result = ")
                console.log(this.searchItemsList)

            }

        },

        //Close search
        closeSearchResults(){
            this.isShowingSearchResults=false
            this.searchPhrase=""
        },

        //Go to Add Item
        goToAddItem(){
            this.$router.push('/additemforsale')
        },
    },

    mounted(){
        this.getItemsForSale()
    },
}
</script>

